/**
 * IPFS image URLs → an ordered list of gateway candidates.
 *
 * Token metadata (pump.fun and most launchpads) points at ipfs.io, which now
 * serves some content behind a Cloudflare bot challenge (403 "Just a moment…")
 * or 429s — an <img> can't pass either, so logos silently broke. We rewrite any
 * IPFS URL (ipfs://, /ipfs/<cid> on any host, <cid>.ipfs.<host>) to fast public
 * gateways first and keep the original as the last resort; components advance
 * to the next candidate on error.
 */
const GATEWAYS = ['https://ipfs.filebase.io/ipfs/', 'https://gateway.pinata.cloud/ipfs/'];

function ipfsPath(url: string): string | null {
  const u = url.trim();
  let m = u.match(/^ipfs:\/\/(?:ipfs\/)?(.+)$/i);
  if (m) return m[1];
  m = u.match(/^https?:\/\/[^/]+\/ipfs\/(.+)$/i);
  if (m) return m[1];
  m = u.match(/^https?:\/\/([a-z0-9]{46,})\.ipfs\.[^/]+(\/.*)?$/i);
  if (m) return m[1] + (m[2] || '');
  return null;
}

export function imageCandidates(url: string | null | undefined): string[] {
  if (!url) return [];
  const path = ipfsPath(url);
  if (!path) return [url];
  const out = GATEWAYS.map(g => g + path);
  if (/^https?:/i.test(url) && !out.includes(url)) out.push(url);
  return out;
}
